import React from "react";
import MonthPicker from "components/ui/form/month-picker";
import { FilterProps, useHandleChange } from "../shared";

const Filter = (props: FilterProps) => {
    const { state, handleChange, isLoading } = props;
    const { handleEventChange } = useHandleChange(handleChange, true);
    const minStartDate = new Date(1980, 1, 1);

    return (
        <div className="row">
            <div className="col">
                <MonthPicker
                    id="startDate"
                    uniqueId="desktop-start-date"
                    disabled={isLoading}
                    initialValue={state.startDate}
                    minDate={minStartDate}
                    maxDate={state.endDate}
                    onChange={handleEventChange}
                    placeholder="From" />
            </div>

            <div className="col">
                <MonthPicker
                    id="endDate"
                    uniqueId="desktop-end-date"
                    disabled={isLoading}
                    initialValue={state.endDate}
                    minDate={state.startDate}
                    maxDate={state.maxDate}
                    onChange={handleEventChange}
                    placeholder="To" />
            </div>
        </div>);

}

export default Filter
